module.exports = __webpack_public_path__ + "static/media/-_Time Management.e4edb8d6.png";